import React from 'react';
import { useTranslation } from '@helpers/translate';
import classnames from 'classnames';
import GoogleIcon from '@assets/icons/GoogleIcon';
import './GoogleButton.sass';

const GoogleButton = ({
  variant = 'light',
  disabled = false,
  className,
  isSignUp = false,
  ...props
}) => {
  const { __ } = useTranslation();
  const buttonText = isSignUp ? __('auth.signUpWithGoogle') : __('auth.signInWithGoogle');
  const variantClass = disabled ? 'google-button--disabled' : `google-button--${variant}`;
  const classes = classnames('google-button', variantClass, className);

  return (
    <button
      className={classes}
      disabled={disabled}
      {...props}
    >
      <GoogleIcon />
      <span className="whitespace-nowrap">
        {buttonText}
      </span>
    </button>
  );
};

export default GoogleButton;

